/**
 * Created by Wiloke on 5/11/15.
 */
(function ($) {
    "use strict";

    $.fn.piMapExtend = function (opts) {
        var self = this,
            stylesDefaults = {
                none : {
                    bgPreview: 'rgba(0,0,0,0)',
                    title : 'None',
                    content : null
                },
                subtleGrayscale: {
                    bgPreview: 'rgba(227, 227, 227, 1)',
                    title : 'Subtle Grayscale',
                    content : [{"featureType":"landscape","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","stylers":[{"saturation":-100},{"lightness":51},{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"road.arterial","stylers":[{"saturation":-100},{"lightness":30},{"visibility":"on"}]},{"featureType":"road.local","stylers":[{"saturation":-100},{"lightness":40},{"visibility":"on"}]},{"featureType":"transit","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"administrative.province","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":-25},{"saturation":-100}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]}]
                },
                appleMapsEsque: {
                    bgPreview : 'rgba(246, 240, 222, 1)',
                    title : 'Apple Maps Esque',
                    content : [{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"color":"#f7f1df"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#d0e3b4"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.medical","elementType":"geometry","stylers":[{"color":"#fbd3da"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#bde6ab"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffe15f"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#efd151"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"color":"black"}]},{"featureType":"transit.station.airport","elementType":"geometry.fill","stylers":[{"color":"#cfb2db"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#a2daf2"}]}]
                },
                blueWater: {
                    bgPreview : 'rgba(70, 188, 236, 1)',
                    title : 'Blue Water',
                    content : [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#46bcec"},{"visibility":"on"}]}]
                },
                shadesOfGrey: {
                    bgPreview : 'rgba(101, 101, 101, 1)',
                    title : 'Shades Of Grey',
                    content : [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}]
                },
                paleDawn: {
                    bgPreview: 'rgba(242, 229, 212, 1)',
                    title : 'Pale Dawn',
                    content : [{"featureType":"administrative","elementType":"all","stylers":[{"visibility":"on"},{"lightness":33}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2e5d4"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#c5dac6"}]},{"featureType":"poi.park","elementType":"labels","stylers":[{"visibility":"on"},{"lightness":20}]},{"featureType":"road","elementType":"all","stylers":[{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#c5c6c6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#e4d7c6"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#fbfaf7"}]},{"featureType":"water","elementType":"all","stylers":[{"visibility":"on"},{"color":"#acbcc9"}]}]
                },
                blueEssence: {
                    bgPreview: 'rgba(190, 230, 230, 1)',
                    title : 'Blue Essence',
                    content : [{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#e0efef"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"hue":"#1900ff"},{"color":"#c0e8e8"}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":100},{"visibility":"simplified"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"visibility":"on"},{"lightness":700}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#7dcdcd"}]}]
                },
                lightMonochrome : {
                    bgPreview : 'rgba(240, 243, 245, 1)',
                    title : 'Light Monochrome',
                    content : [{"featureType":"administrative.locality","elementType":"all","stylers":[{"hue":"#2c2e33"},{"saturation":7},{"lightness":19},{"visibility":"on"}]},{"featureType":"landscape","elementType":"all","stylers":[{"hue":"#ffffff"},{"saturation":-100},{"lightness":100},{"visibility":"simplified"}]},{"featureType":"poi","elementType":"all","stylers":[{"hue":"#ffffff"},{"saturation":-100},{"lightness":100},{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"hue":"#bbc0c4"},{"saturation":-93},{"lightness":31},{"visibility":"simplified"}]},{"featureType":"road","elementType":"labels","stylers":[{"hue":"#bbc0c4"},{"saturation":-93},{"lightness":31},{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"labels","stylers":[{"hue":"#bbc0c4"},{"saturation":-93},{"lightness":-2},{"visibility":"simplified"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"hue":"#e9ebed"},{"saturation":-90},{"lightness":-8},{"visibility":"simplified"}]},{"featureType":"transit","elementType":"all","stylers":[{"hue":"#e9ebed"},{"saturation":10},{"lightness":69},{"visibility":"on"}]},{"featureType":"water","elementType":"all","stylers":[{"hue":"#e9ebed"},{"saturation":-78},{"lightness":67},{"visibility":"simplified"}]}]
                },
                retro : {
                    bgPreview : 'rgba(166, 156, 137, 1)',
                    title : 'Retro',
                    content: [{"featureType":"administrative","stylers":[{"visibility":"off"}]},{"featureType":"poi","stylers":[{"visibility":"simplified"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"water","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","stylers":[{"visibility":"simplified"}]},{"featureType":"landscape","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","stylers":[{"visibility":"off"}]},{"featureType":"road.local","stylers":[{"visibility":"on"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"water","stylers":[{"color":"#84afa3"},{"lightness":52}]},{"stylers":[{"saturation":-17},{"gamma":0.36}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#3f518c"}]}]
                },
                blueGray : {
                    bgPreview : 'rgba(166, 156, 137, 1)',
                    title : 'Retro',
                    content: [{"featureType": "water","stylers": [{"visibility": "on"},{"color": "#b5cbe4"}]},{"featureType": "landscape","stylers": [{"color": "#efefef"}]},{"featureType": "road.highway","elementType": "geometry","stylers": [{"color": "#83a5b0"}]},{"featureType": "road.arterial","elementType": "geometry","stylers": [{"color": "#bdcdd3"}]},{"featureType": "road.local","elementType": "geometry","stylers": [{"color": "#ffffff"}]},{"featureType": "poi.park","elementType": "geometry","stylers": [{"color": "#e3eed3"}]},{"featureType": "administrative","stylers": [{"visibility": "on"},{"lightness": 33}]},{"featureType": "road"},{"featureType": "poi.park","elementType": "labels","stylers": [{"visibility": "on"},{"lightness": 20}]},{},{"featureType": "road","stylers": [{"lightness": 20}]}]
                }
            },
            defaults = {
                zoom : 15,
                scrollwheel: false,
                extendStyle : {},
                stylesDefaults: stylesDefaults,
                styleActive : 'none',
                autoZoom: false,
                listLocation : [],
                listDestination: [],
                triggerMarker : true,
                showListLocation : true,
                multiExtend: true,
                widthMobile : 768,
                infoOpenFirst : false,
                useLink : true, // type of true or false
                textLink: 'Scroll to<i class="fa fa-angle-down"></i>', // Only work with option useLink is true
                menuFixed : '.header-inner',
                titleDesktop: '<h2 id="pi_map_sidebar_title">Destinations <i class="fa fa-angle-down"></i></h2>',
                initMap: function(obj) {}, // load done
                changeMarker : function(obj) {},
                beforeResize: function (obj) {},
                afterResize : function (obj) {},
                scrollTo: function (obj) {}
            },
            options = $.extend(defaults, opts);
        options.styles =  $.extend(options.stylesDefaults, options.extendStyle);

        // Create variables
        var ww = window.innerWidth,
            wh = window.innerHeight,
            sw = self.width(),
            sh = self.height(),
            $nav = $('<div class="pi-nav-map"></div>'),
            $contents = $('<div class="pi-contents-map"></div>'),
            $title = $('<div class="pi-map-title"></div>'),
            $link = $('<div class="pi-scrollto"></div>');

        self.piMap = {
            options : options,
            el: self,
            init : function () {

                // Check mobile
                this.checkMobile();

                // Create HTML
                this.createHTML();

                // Create maps
                this.createMap();

                // Create InfoWindow
                this.createInfoWindow();

                // Create Select choose point list map
                this.createListLocation();

                this.setMarker();

                this.listenEvent();

                // apply callback
                options.initMap(this);
            },
            createHTML: function () {
                var _this = this;

                // Add Class default extend map
                _this.el.addClass('pi-extend-map-wrapper');

                _this.$nav = $nav;
                _this.$contents = $contents;
                _this.$title = $title;
                _this.$link = $link;

                _this.el.append(_this.$contents);
                // Setting title control in screen desktop
                _this.$title.append(options.titleDesktop);

                // Setting text button next in mobile
                _this.$link.append(options.textLink);

                // Check setting of plugin
                if (options.showListLocation) {
                    _this.el.append(_this.$nav);
                }
            },
            createMap: function () {
                var _this = this;

                // Create center google map defaults
                _this.center = new google.maps.LatLng(47.692927, 4.253153);
                _this.indexGroup = 0;
                _this.indexItem = 0;
                _this.mapOptions = {
                    zoom: options.zoom,
                    center: _this.center,
                    scrollwheel : options.scrollwheel,
                    styles : options.styles[options.styleActive] != undefined ? options.styles[options.styleActive].content : null,
                    mapTypeControlOptions: {
                        position: google.maps.ControlPosition.RIGHT_TOP
                    },
                    panControlOptions:{
                        position: google.maps.ControlPosition.RIGHT_TOP
                    },
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.RIGHT_TOP
                    }
                };

                // Call google maps
                _this.map = new google.maps.Map(_this.$contents[0], _this.mapOptions);
            },
            setMarker: function () {
                var _this = this;
                _this.markers = [];

                $.each (options.listLocation, function (index, location) {
                    var newMarker = new google.maps.Marker ({
                        map: _this.map,
                        title: location.marker.title,
                        icon: location.marker.icon != '' ? location.marker.icon : null,
                        position: new google.maps.LatLng(location.marker.position[0], location.marker.position[1]),
                        animation: location.marker.animation ? google.maps.Animation.BOUNCE : null
                    });

                    _this.markers[index] = newMarker;

                    // Create Event marker

                    google.maps.event.addListener(_this.markers[index], 'click', function () {
                        // Check image loaded
                        var $info = $(location.info.content),
                            $img = $('img', $info);

                        if ($img.length) {
                            _this.el.addClass('loading-image');
                            $.imageLoaded({src  : $img.attr('src')}, function () {
                                if(status.err) {
                                    return;
                                }
                                imageLoaded(location, index);
                            });
                        }
                        else {
                            imageLoaded(location, index);
                        }
                    });

                });
                function imageLoaded(location, index) {
                    // remove Class loading image
                    if (_this.el.hasClass('loading-image')) {
                        _this.el.removeClass('loading-image');
                    }


                    _this.infoWindow.close(); //hide the infowindow
                    _this.infoWindow.setContent('<div class="pi-infor-maker">'+ location.info.content +'</div>');//update the content for this marker
                    _this.infoWindow.open(_this.map, _this.markers[index]);

                    $.each (_this.markers, function (idMarker, marker) {
                        _this.markers[idMarker].setAnimation(null);
                    });
                    if (location.marker.animation) {
                        if (_this.markers[index].getAnimation() != null) {
                            _this.markers[index].setAnimation(null);
                        } else {
                            _this.markers[index].setAnimation(google.maps.Animation.BOUNCE);
                        }
                    }

                    // Set map center
                    _this.map.panTo(_this.markers[index].getPosition());


                    var latlng = location.marker.position,
                        destination = location.destination,
                        $spanDestination = $('span[data-value="'+ destination +'"]'),
                        $items = $spanDestination.parent('.items-location-group'),
                        $location = $('.item-location[data-value="'+ latlng.join(',') +'"]', $items);

                    _this.activeGroup($items);
                    _this.activeItem($location);
                    _this.$listMobile.val(latlng.join(','));
                    // apply callback showInfo
                    options.changeMarker(_this);
                }
            },
            activeGroup: function ($group) {
                var _this = this;

                if (!options.multiExtend) {
                    $group.siblings('.active').each(function () {
                        _this.deactivateGroup($(this));
                    });
                }
                if (!$group.hasClass('active')) {
                    $group.addClass('active');
                    $('.list-location-group', $group).slideDown(200);
                }
            },
            deactivateGroup: function ($group) {
                var _this = this,
                    index = $group.index();

                if ($group.hasClass('active')) {
                    $group.removeClass('active');
                    $('.list-location-group', $group).slideUp(200);
                }
            },
            activeItem: function ($item) {
                var _this = this;

                $('.item-location', _this.$listDesktop).removeClass('active');
                if (!$item.hasClass('active')) {
                    $item.addClass('active');
                }
            },
            createInfoWindow: function () {
                this.infoWindow = new google.maps.InfoWindow();
                return this.infoWindow;
            },
            createListLocation: function () {
                var _this = this;

                _this.createListLocationDesktop();
                _this.createListLocationMobile();
                _this.processListLocation();

            },
            createListLocationDesktop: function () {
                var _this = this;

                // Create HTML in screen desktop
                _this.$listDesktop = $('<div class="pi-map-list-control"><div class="pi-scrollbar"><ul class="pi-map-list-location pi-map-group"></ul></div></div>');

                var $titleDesktop = $('<div class="pi-desktop-title"></div>'),
                    $listLocation = $('.pi-map-list-location', _this.$listDesktop);

                $titleDesktop.append(options.titleDesktop);
                _this.$listDesktop.prepend($titleDesktop);

                // Create location group
                $.each(options.listDestination, function (index, destination) {
                    var $locationGroup = $('<li class="items-location-group"></li>'),
                        $name = $('<span class="name-group" data-value=""></span>'),
                        $list = $('<ul class="list-location-group"></ul>');

                    $name.html(destination).attr('data-value', destination);
                    $locationGroup.append($name);
                    $locationGroup.append($list);
                    $listLocation.append($locationGroup);
                });

                // Create location item
                $.each(options.listLocation, function (index, location) {
                    var $location = $('<li class="item-location"></li>'),
                        $spanLocationGroup = $('span[data-value="'+ location.destination +'"]', _this.$listDesktop),
                        $listLocation = $spanLocationGroup.next('.list-location-group');

                    $location.html(location.marker.title).attr({
                        'data-value': location.marker.position.join(','),
                        'data-index': index
                    });
                    $location.prepend('<i class="fa fa-map-marker"></i>');
                    $listLocation.append($location);
                });
            },
            createListLocationMobile: function () {
                var _this = this;

                // Create HTML in screen mobile
                _this.$listMobile = $('<select class="pi-map-list-location-mobile pi-map-group"></select>');

                // Create location group
                $.each(options.listDestination, function (index, destination) {
                    var $locationGroup = $('<optgroup class="items-location-group"></optgroup>');

                    $locationGroup.attr('label', destination).attr('data-value', destination);
                    _this.$listMobile.append($locationGroup);
                });

                $.each(options.listLocation, function (index, location) {
                    var $location = $('<option  class="item-location"></option >'),
                        $group = $('.items-location-group[data-value="'+ location.destination +'"]', _this.$listMobile);

                    $location.html(location.marker.title).attr({
                        'value': location.marker.position.join(','),
                        'data-index' : index
                    });
                    $group.append($location);
                });
            },
            perfectScrollBar: function () {
                var _this = this;

                $('.ps-scrollbar-x-rail', _this.$listDesktop).remove();
                $('.ps-scrollbar-y-rail', _this.$listDesktop).remove();
                $('.pi-scrollbar', _this.$listDesktop).perfectScrollbar();
            },
            processListLocation: function () {
                var _this = this;

                ww = window.innerWidth;
                sw = _this.el.width();
                if (_this.isMobile != null) {
                    _this.$nav.empty();
                    _this.$nav.append(_this.$listMobile);
                    _this.$nav.append(_this.$link);
                }
                else {
                    if (ww > options.widthMobile) {
                        if (!$('.pi-map-list-location').length) {
                            _this.$nav.empty();
                            _this.$nav.append(_this.$listDesktop);
                            _this.perfectScrollBar();

                        }
                    }
                    else {
                        if (!$('.pi-map-list-location-mobile').length) {
                            _this.$nav.empty();
                            _this.$nav.append(_this.$listMobile);
                            _this.$nav.append(_this.$link);
                        }
                    }
                }
            },
            checkMobile: function () {
                var _this = this,
                    isMobile = {
                        Android: function() {
                            return navigator.userAgent.match(/Android/i);
                        },
                        BlackBerry: function() {
                            return navigator.userAgent.match(/BlackBerry/i);
                        },
                        iOS: function() {
                            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                        },
                        Opera: function() {
                            return navigator.userAgent.match(/Opera Mini/i);
                        },
                        Windows: function() {
                            return navigator.userAgent.match(/IEMobile/i);
                        },
                        any: function() {
                            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
                        }
                    }

                _this.isMobile = isMobile.any();
            },
            listenEvent: function () {
                var _this = this;
                _this.el.delegate('.pi-desktop-title', 'click', function () {
                    var $scrollbar = $('.pi-scrollbar', _this.el);
                    if (_this.$nav.hasClass('pi-nav-map-hide')) {
                        _this.$nav.removeClass('pi-nav-map-hide');
                        $scrollbar.slideDown(500);
                    }
                    else {
                        _this.$nav.addClass('pi-nav-map-hide');
                        $scrollbar.slideUp(500);
                    }
                });

                _this.el.delegate('.name-group', 'click', function (event) {
                    event.stopPropagation();
                    var $itemsLocation = $(this).parent(),
                        index = $itemsLocation.index();
                    if (options.showListLocation) {
                        if ($itemsLocation.hasClass('active')) {
                            _this.deactivateGroup($itemsLocation);
                        }
                        else {
                            _this.activeGroup($itemsLocation);

                            // PanTo center map
                            if ($('.item-location', $itemsLocation).eq(0).length) {
                                if (!options.autoZoom) {
                                    var $childFirst = $('.item-location', $itemsLocation).eq(0),
                                        latlng = $childFirst.data('value').split(','),
                                        center = new google.maps.LatLng(latlng[0], latlng[1]);

                                    _this.map.panTo(center);
                                }
                                else {
                                    var bounds = new google.maps.LatLngBounds ();
                                    $.each ($('.item-location', $itemsLocation), function () {
                                        var index = $(this).data('index'),
                                            location = options.listLocation[index].marker.position,
                                            apiLocation = new google.maps.LatLng (location[0],location[1]);
                                        bounds.extend(apiLocation);
                                    });
                                    _this.map.fitBounds (bounds);
                                }

                            }
                        }
                    }
                });

                _this.el.delegate('.item-location', 'click', function (event) {
                    event.stopPropagation();

                    if (options.showListLocation) {
                        var $location = $(event.target).hasClass('item-location') ? $(event.target) : $(event.target).closest('.item-location'),
                            index = $location.data('index');

                        google.maps.event.trigger (_this.markers[index], 'click');
                    }
                });

                _this.el.delegate('.pi-map-list-location-mobile', 'change', function (event) {
                    event.stopPropagation();

                    var lagLong = $(this).val();
                    $.each($('.item-location', _this.$listMobile), function () {
                        if ($(this).attr('value') == lagLong) {
                            var index = $(this).data('index');
                            google.maps.event.trigger (_this.markers[index], 'click');
                        }
                    });
                });

                _this.el.delegate('.pi-scrollto', 'click', function () {
                    _this.scrollTo();
                });

                // Window resize
                $(window).resize( function () {
                    _this.resize();
                });
            },
            resize: function () {
                var _this = this;

                // Apply callback resize
                options.beforeResize(_this);

                _this.processListLocation();

                // Apply callback resize
                options.afterResize(_this);
            },
            scrollTo: function () {
                var _this = this,
                    $next = _this.el.next(),
                    heightMenu = $(options.menuFixed).outerHeight(),
                    offsetTop = $next.offset().top - heightMenu;

                $('body').animate({
                    scrollTop: offsetTop
                }, 300);

                // Apply callback scroll to
                options.scrollTo(_this);
            }
        };
        self.piMap.init();
    };
    $.imageLoaded = function(options, callback) {
        var seconds = 0,
            maxSeconds = 10,
            complete = false,
            done = false;

        if (options.maxSeconds) {
            maxSeconds = options.maxSeconds;
        }

        function tryImage() {
            if (done) { return; }
            if (seconds >= maxSeconds) {
                callback({ err: 'timeout' });
                done = true;
                return;
            }
            if (complete && img.complete) {
                if (img.width && img.height) {
                    callback({ img: img });
                    done = true;
                    return;
                }
                callback({ err: '404' });
                done = true;
                return;
            } else if (img.complete) {
                complete = true;
            }
            seconds++;
            callback.tryImage = setTimeout(tryImage, 1000);
        }
        var img = new Image();
        img.onload = tryImage();
        img.src = options.src;
        tryImage();
    }
})(jQuery)
